<template>
  <div class="d-inline-block bg-warning-light rounded px-3 py-2 font-weight-bold">
    {{ value.replace(/(.{4})/g, "$1 ").trim() }}
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  }
}
</script>
